/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@mui/material';
import Styles from './styles';

const useStyles = makeStyles(Styles);

export default function ConfirmModal({ title, text, submitText, cancelText, onCancel, onSubmit }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');

  return (
    <div data-testid="confirm-modal" className={classes.modalWrapper}>
      <Typography className={classes.modalHeader} variant="h5" component="h5">
        {title}
      </Typography>

      <div className={classes.formDescription}>
        <Typography className={classes.subtitleText} variant="body1" component="p">
          {text}
        </Typography>
      </div>
      <div className={classes.formControls}>
        <Button data-testid="cancel" onClick={onCancel} variant="outlined" color="error" size="large">
          <Typography variant="body1" component="span">
            {cancelText || t('cancel')}
          </Typography>
        </Button>
        <Button data-testid="confirm" className={classes.confirmButton} onClick={onSubmit} variant="contained" color="error" size="large">
          <Typography variant="body1" component="span">
            {submitText || t('ok')}
          </Typography>
        </Button>
      </div>
    </div>
  );
}

ConfirmModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string,
  text: PropTypes.string,
  submitText: PropTypes.string,
  cancelText: PropTypes.string,
};

ConfirmModal.defaultProps = {
  title: '',
  text: '',
  submitText: '',
  cancelText: '',
};
